ixModuleRouting("impactx.statistic", {
    "/orderstatvariablelist": {
        template: '<ixa-order-stat-variable-list></ixa-order-stat-variable-list>',
        templateUrl: "modules/statistic/templates/orderstatvariablelist.html",
        process: "OrderStatVariable",
        controller: "OrderStatVariableListCtrl",
        controllerAs: "orderStatVariableListCtrl",
        workspace: "monitor",
    },
    '/reportstatuserlist': {
        template: '<ixa-report-stat-user-list></ixa-report-stat-user-list>',
        templateUrl: 'modules/statistic/templates/reportstatuserlist.html',
        process: "ReportStatUser",
        controller: 'ReportStatUserListCtrl',
        controllerAs: 'reportStatUserListCtrl',
        workspace: 'monitor',
    },
});
